import { useStore } from './useStore';

export function useDispatch() {
    const [, dispatch] = useStore();
    return dispatch;
}
